import axios from "axios";
import utils from "../utils";
import { Message } from "element-ui";
import moment from "moment";
// import ERROR_TYPE from "../config";
// import commonCanstant from "src/constant/index.js";

const request = axios.create();
let copyConfig = {};
request.interceptors.request.use(
  config => {
    // 设置 header
    var headerData = utils.getRequestHeader();
    if (config.url === "api/server/serverLoginAuth") {
      const { search } = window.location;
      let loginToken, productId;
      if (search.match(/loginToken/)) {
        let strArr = search.slice(1).split("&");
        strArr = strArr.map(ele => {
          return decodeURIComponent(ele);
        });
        strArr.forEach(item => {
          if (item.match(/loginToken/)) {
            loginToken = item.split("=")[1];
          } else if (item.match(/productId/)) {
            productId = item.split("=")[1];
          }
        });
      } else {
        loginToken = sessionStorage.getItem("loginToken");
        productId = sessionStorage.getItem("productId");
      }
      headerData.token = loginToken;
      headerData.productId = productId;
    }

    // 导出
    if (config.url.indexOf("/api/cusServer/exportExcel") >= 0) {
      config.responseType = "blob";
    }

    // 下单接口超时处理
    switch (config.url) {
      case "/api/recharge/payment":
        config.timeout = 300000;
        break;
      case "/api/server/cUsers":
        config.timeout = 30000;
        break;
      case "/api/server/hisUsers":
        config.timeout = 30000;
        break;
      case "/api/server/cOffUsers":
        config.timeout = 30000;
        break;
      default:
        config.timeout = 20000;
        break;
    }
    // if (config.url === "/api/recharge/payment") {
    //   config.timeout = 300000;
    // } else {
    //   config.timeout = 20000;
    // }
    config.headers = {
      ...headerData
    };
    copyConfig = config;

    utils.log(
      "request",
      `${config.url} => ${JSON.stringify(config.data || {})}`
    );
    if (config["Content-Type"] === "multipart/form-data;charset=utf-8") {
      // 上传文件时，指定config中Content-Type为multipart/form-data;charset=utf-8
      // do nothing
    } else {
      if (config.method === "post") {
        config.data = {
          encryptParam: utils.RSAEncrypt(JSON.stringify(config.data))
        };
      }
    }
    return config;
  },
  error => {
    console.log(error);
    console.log("请求错误");
    return Promise.reject(error);
  }
);

request.interceptors.response.use(
  response => {
    let res = response.data;
    utils.log(
      "api 服务器时间",
      moment(response.headers.date).format("YYYY-MM-DD HH:mm:ss")
    );
    return res;
  },
  async error => {
    console.log(error);
    let code = 0;
    // const device = utils.getdev();
    try {
      code = error.response.data.status;
    } catch (e) {
      console.log(e);
      console.log("响应错误");
      if (error.toString().indexOf("Error: timeout") !== -1) {
        Message.closeAll();
        Message.error({
          message: "请求响应过慢，请确认网络",
          duration: 5000
        });
        // return Promise.reject(error);
        if (copyConfig.url === "/api/user/msg") {
          return false;
        }
        return false;
      }
    }
    // setTimeout(() => {
    //   utils.getlog({
    //     appId: device,
    //     // productId: commonCanstant.PRODUCTID,
    //     productId: sessionStorage.getItem("productId"),
    //     time: new Date(),
    //     lever: ERROR_TYPE.ERROR_TYPE.FATAL,
    //     msg: JSON.stringify(error)
    //   });
    // }, 0);
    if (code) {
      if (copyConfig.url == "/api/common/collection") {
        return false;
      }
      if (code === 420) {
        console.log("420");
        if (copyConfig.url !== "/api/customer/end") {
          Message.closeAll();
          Message.warning(error.response.data.message);
        }
        // if (copyConfig.url === "/api/customer/channel") {
        //   Message.warning(error.response.data.message);
        // }
        return false;
      }

      if (code === 400) {
        if (error.response.data.message == "请求参数错误") {
          if (copyConfig.url === "/api/user/msg") {
            Message.closeAll();
            Message.warning("发送失败请重试！");
          }
          return false;
        }
        Message.closeAll();
        Message.warning(error.response.data.message);
        return;
      }
    }

    if (!window.navigator.onLine) {
      Message.closeAll();
      Message.warning("工作台本地网络不佳，请确认本地网络");
      return;
    }
    if (error.response && error.response.status === 500) {
      Message.closeAll();
      Message.warning("系统繁忙，请稍后再试！【服务器错误】！");
      return;
    }
    if (error.response && error.response.status === 506) {
      Message.closeAll();
      Message({
        message: "登录已失效，请重新进入！",
        type: "error",
        duration: 50000
      });
      return;
    }
    // if (
    //   copyConfig.url !== "/api/common/information" &&
    //   copyConfig.url !== "/api/common/heartbeatMonitor" &&
    //   copyConfig.url !== "/api/cusCustomer/queryCusQueue"
    // ) {
    //   // Message.error(_.get(error, "response.data.message", "请求错误"));
    // }
    // console.log(copyConfig.url);
    // console.log("捕捉错误code");
    return Promise.reject(error);
  }
);

export default request;
